import { isOrganizationLevelRoute } from '@/lib/routerUtils'
import type { ConsoleUser, PlatformUser } from '@/stores/auth'
import { resolveRootTenantIdFromUser } from '@/utils/permissions'

export function resolveQuotaTenantId(options: {
	currentTenant: string | null | undefined
	pathname: string
	rootTenantId: string | null
	organizationId: string | null | undefined
	user: ConsoleUser | PlatformUser | null
}): string | null {
	const trimmedTenant = options.currentTenant?.trim()
	if (trimmedTenant) {
		return trimmedTenant
	}

	if (!isOrganizationLevelRoute(options.pathname)) {
		return null
	}

	return options.rootTenantId ?? resolveRootTenantIdFromUser(options.user, options.organizationId ?? '') ?? null
}
